import { useState, useEffect, useRef } from 'react';
import { withWindow } from '@shared/utils/withWindow';
import { withGoogleMaps } from '@static/js/googleMaps';

export const useGoogleMaps = (): [typeof google.maps | null, { loading: boolean }] => {
  const [loadingGoogleMaps, setLoadingGoogleMaps] = useState(true);
  const googleMapsRef = useRef<typeof google.maps | null>(null);

  useEffect(() => {
    const googleMaps = withWindow(global => global.google?.maps, null);

    if (googleMaps) {
      googleMapsRef.current = googleMaps;
      setLoadingGoogleMaps(false);
      return;
    }

    const loadGoogleMaps = () => {
      withGoogleMaps(googleMapsLoaded => {
        googleMapsRef.current = googleMapsLoaded;
        setLoadingGoogleMaps(false);
      });
    };

    loadGoogleMaps();
  }, []);

  return [googleMapsRef.current, { loading: loadingGoogleMaps }];
};
